import React, { useCallback } from "react";
import { Button, Card, Tooltip, Typography } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { navigateAgentPackageUpgrade } from "../../utils/agentUpgradeNavigation";
import "./FeatureGuardCard.scss";

const { Title } = Typography;

/**
 * כרטיס עם מצב נעילה אחיד לפי entitlement — ללא שכפול לוגיקת כפתורי שדרוג.
 */
export function FeatureGuardCard({
  isEnabled,
  title,
  lockedTooltip,
  lockedBodyText,
  upgradeButtonText = "שדרג ל-PRO",
  upgradeSource = "feature_guard_card",
  children,
}) {
  const navigate = useNavigate();
  const onUpgrade = useCallback(() => {
    navigateAgentPackageUpgrade(navigate, upgradeSource);
  }, [navigate, upgradeSource]);

  if (isEnabled) {
    return (
      <Card title={title} className="feature-guard-card">
        {children}
      </Card>
    );
  }

  const card = (
    <Card
      title={title}
      className="feature-guard-card feature-guard-card--locked"
      bodyStyle={{ position: "relative" }}
    >
      <div className="feature-guard-card__ghost-wrap" aria-hidden>
        <div className="feature-guard-card__ghost-lines">
          <span className="feature-guard-card__ghost-line feature-guard-card__ghost-line--lg" />
          <span className="feature-guard-card__ghost-line" />
          <span className="feature-guard-card__ghost-line" />
        </div>
      </div>
      <div className="feature-guard-card__locked-content">
        <LockOutlined className="feature-guard-card__lock-icon" aria-hidden />
        <Title level={4} className="feature-guard-card__locked-title">
          {lockedBodyText}
        </Title>
        <Button type="primary" size="small" onClick={onUpgrade}>
          {upgradeButtonText}
        </Button>
      </div>
    </Card>
  );

  return (
    <Tooltip title={lockedTooltip} placement="top" mouseEnterDelay={0.15}>
      <div className="feature-guard-card__tooltip-anchor">{card}</div>
    </Tooltip>
  );
}
